import * as React from "react";
const SvgCompressRight = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M13.5671 7.02953L19.9105 0.769348L21.3154 2.19288L14.9916 8.43359L18.5615 8.44778L18.5535 10.4478L11.5536 10.4199L11.5814 3.41999L13.5814 3.42794L13.5671 7.02953Z" }), /* @__PURE__ */ React.createElement("path", { d: "M6.97885 13.5429L3.40892 13.5457L3.40735 11.5457L10.4074 11.5402L10.4128 18.5402L8.41283 18.5418L8.41001 14.9403L2.09629 21.2307L0.684692 19.8138L6.97885 13.5429Z" }));
export default SvgCompressRight;
